import { ACTION_TYPE } from './action';

const mailMagazines = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.INIT_MAIL_MAGAZINE_LIST_SUCCESS:
      return {
        ...state,
        selects: action.selects,
      };
    case ACTION_TYPE.CALL_API_MAIL_MAGAZINE_LIST_SUCCESS:
      return {
        ...state,
        datas: action.datas,
      };
    case ACTION_TYPE.CALL_API_DELETE_MAIL_MAGAZINE_SUCCESS:
      return {
        ...state,
        isDeleteSuccess: true,
      };
    case ACTION_TYPE.CALL_API_DELETE_MAIL_MAGAZINE:
      return {
        ...state,
        isDeleteSuccess: false,
      };
    case ACTION_TYPE.SET_SEARCH_MAIL_MAGAZINES:
      return {
        ...state,
        searchCondition: action.searchCondition,
      };
    default:
      return state;
  }
};

export default mailMagazines;
